import moment from 'moment';
import routes from 'routes';
import { Conversation_externalLead_conversation } from 'types/apollo/Conversation';
import { ExportDetails, Message } from '../../views/company/chat-conversation/chat-conversation';
import { encodeExportDetails } from '../../views/company/chat-conversation/utils/decode.util';

export const transformAndEncodeConversationToExportUrl = async (
  conversation: Conversation_externalLead_conversation[],
) => {
  const exportData: ExportDetails = {
    leadSource: '',
    messages: conversation
      .filter(
        (event) => event.inboundSms || event.outboundSms || event.inboundCall || event.outboundCall,
      )
      .map((event, index): Message => {
        let sender: Message['sender'] = 'Inbound';
        let text = '[Unknown message]';

        if (event.outboundSms) {
          sender = 'Outbound';
          text = event.outboundSms.body;
        } else if (event.inboundSms) {
          sender = 'Inbound';
          text = event.inboundSms.body;
        } else if (event.inboundCall) {
          sender = 'InboundCall';
          text = 'Inbound call';
        } else if (event.outboundCall) {
          sender = 'OutboundCall';
          text = 'Outbound call';
        }

        return {
          id: `${index + 1}`,
          sender,
          text,
          time: moment(event.time).toISOString(),
          isDnc: event.inboundCall?.isDnc || event.outboundCall?.isDnc,
          isTransfer: event.inboundCall?.isTransfer || event.outboundCall?.isTransfer,
          noResponse: event.inboundCall?.noResponse,
          isReschedule: event.outboundCall?.isReschedule,
        };
      }),
  };

  const encoded = await encodeExportDetails(exportData);
  return `${routes.company.campaign.chatConversation.path}#${encoded}`;
};
